/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Suspense } from "react";
import Loader from "./Loader";

// Note: This uses Currying!

const Loadable = (Component) => (props) => {

    return (
        <Suspense fallback={<Loader />}>
            <Component {...props} />
        </Suspense>
    );
};

Loadable.displayName = "Loadable";
export { Loadable };
